import { render, staticRenderFns } from "./RoleEditForm.vue?vue&type=template&id=e744fe10&scoped=true"
import script from "./RoleEditForm.vue?vue&type=script&lang=js"
export * from "./RoleEditForm.vue?vue&type=script&lang=js"
import style0 from "./RoleEditForm.vue?vue&type=style&index=0&id=e744fe10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e744fe10",
  null
  
)

export default component.exports